import React from 'react';
import HomePageFirstSection from './HomePageFirstSection';
import HomePageSecondSection from './HomePageSecondSection';

function Home() {
    return(
        <>
        <HomePageFirstSection/>
        <HomePageSecondSection/>
        </>
    )
}

export default Home;